/* MinhandBros product-page blocks (see snippets/mb-pdp.liquid). Round 1 approved by Minh 2026-10-30; round 2 (every product) 2026-10-31. */
(function () {
  if (window.MBP) return;
  var d = document;
  var root = d.querySelector('[data-mbp]');
  if (!root) return;
  var readout = d.querySelector('[data-mbp="size"]');
  var MBP = (window.MBP = {
    model: root.getAttribute('data-model'),
    shape: readout ? readout.getAttribute('data-shape') : '',
    style: (readout || root).getAttribute('data-style') || '',
    pre: (readout ? readout.getAttribute('data-pre') : root.getAttribute('data-style')) || ''
  });

  // Sizes of this model ({key, chip, din, dcm, win, wcm, hcm, fit}) and the size key of each variant id.
  var data = { sizes: [], variants: {} };
  var dataEl = d.querySelector('script[data-mbp-sizes]');
  try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
  function sizeOf(key) { for (var i = 0; i < data.sizes.length; i++) if (data.sizes[i].key === key) return data.sizes[i]; return null; }

  // 1. Size readout under the size buttons, following the chosen size.
  var current = null;
  function setReadout(key) {
    var sz = sizeOf(key);
    if (!readout) return;
    if (!sz) { readout.hidden = true; return; }
    current = sz.key;
    readout.hidden = false;
    var set = function (k, v) { var el = readout.querySelector('[data-k="' + k + '"]'); if (el) el.textContent = v; };
    set('din', sz.din); set('dcm', sz.dcm); set('fit', sz.fit);
  }
  if (readout) {
    var first = d.querySelector('form[id^="product-form-"] input[name="id"]');
    current = (first && data.variants[first.value]) || null;
  }
  d.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && data.variants[v.id]) setReadout(data.variants[v.id]);
  });
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && data.variants[t.value]) setReadout(data.variants[t.value]);
  }, true);

  // 2. Size-guide sheet: size chips, the to-scale drawing (assets/mb-pdp-draw.js), the size table.
  var sheet = d.querySelector('[data-mbp-sheet]');
  if (sheet) d.body.appendChild(sheet);
  function styleOption() {
    var opts = d.querySelectorAll('#avpoptions-container__v2 .avp-option');
    for (var i = 0; i < opts.length; i++) {
      var title = opts[i].querySelector('label.avp-option-title');
      if (title && /macrame style/i.test(title.textContent)) return opts[i];
    }
    return null;
  }
  MBP.styleOption = styleOption;
  function showSize(key) {
    var sz = sizeOf(key) || data.sizes[0];
    if (!sheet || !sz) return;
    sheet.querySelector('[data-mbp-scene]').innerHTML = window.MBPDraw ? window.MBPDraw.scene(sz) : '';
    [].forEach.call(sheet.querySelectorAll('[data-key]'), function (el) { el.classList.toggle('is-on', el.getAttribute('data-key') === sz.key); });
  }
  var lastFocus = null;
  function openSheet() {
    if (!sheet) return;
    lastFocus = d.activeElement;
    showSize(current);
    sheet.hidden = false;
    d.documentElement.classList.add('mbp-lock');
    var x = sheet.querySelector('.mbp-x'); if (x) x.focus();
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    d.documentElement.classList.remove('mbp-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // 3. Christmas line: shown until the cut-off date in US Pacific time, then switched off.
  function delivery() {
    var today;
    try { today = +new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).replace(/\D/g, ''); } catch (e) { return; }
    [].forEach.call(d.querySelectorAll('.mbp-xmas'), function (el) {
      el.hidden = !(today >= +el.getAttribute('data-from') && today <= +el.getAttribute('data-until'));
    });
  }

  // 4. Customer photos from the Judge.me reviews further down the page.
  var lightbox = null;
  function openPhoto(src) {
    if (!lightbox) {
      lightbox = d.createElement('div');
      lightbox.className = 'mbp-lb';
      lightbox.setAttribute('data-mbp-lb', '');
      lightbox.innerHTML = '<button type="button" class="mbp-x" aria-label="Close">&times;</button><img alt="Customer photo">';
      d.body.appendChild(lightbox);
    }
    lightbox.querySelector('img').src = src;
    lightbox.hidden = false;
    d.documentElement.classList.add('mbp-lock');
  }
  function reviewsWidget() { return d.querySelector('.jdgm-widget.jdgm-review-widget, #judgeme_product_reviews'); }
  function ugc() {
    var box = d.querySelector('[data-mbp="ugc"]');
    var seen = {}, pics = [];
    [].forEach.call(d.querySelectorAll('img.jdgm-gallery__thumbnail, .jdgm-rev__pics img'), function (img) {
      var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
      if (!/^https?:/.test(src)) return;
      var key = src.split('?')[0];
      if (seen[key]) return;
      seen[key] = 1;
      var link = img.closest('a');
      var big = img.getAttribute('data-mfp-src') || (link && link.href) || src;
      pics.push({ src: src.replace(/width=\d+/, 'width=240'), big: big.replace(/width=\d+/, 'width=1024') });
    });
    if (!pics.length) return false;
    [].forEach.call(d.querySelectorAll('[data-mbp-ifphotos]'), function (el) { el.hidden = false; });
    if (!box) return true;
    var widg = d.querySelector('.jdgm-rev-widg');
    var avg = widg ? parseFloat(widg.getAttribute('data-average-rating')) : NaN;
    var n = widg ? parseInt(widg.getAttribute('data-number-of-reviews'), 10) : NaN;
    var stars = box.querySelector('[data-k="stars"]'), avgEl = box.querySelector('[data-k="avg"]'), all = box.querySelector('[data-k="all"]');
    if (avg > 0) { stars.style.setProperty('--mbp-r', Math.min(1, avg / 5)); avgEl.textContent = avg.toFixed(1); }
    else { stars.hidden = true; avgEl.hidden = true; }
    if (n > 0) all.textContent = n === 1 ? 'Read the review' : 'See all ' + n + ' reviews';
    box.querySelector('[data-k="row"]').innerHTML = pics.slice(0, 8).map(function (p) {
      return '<button type="button" class="mbp-ph" data-mbp-photo="' + p.big.replace(/"/g, '&quot;') + '"><img src="' + p.src.replace(/"/g, '&quot;') + '" alt="Customer photo" loading="lazy"></button>';
    }).join('');
    box.hidden = false;
    return true;
  }

  // 6. Preselect the colour of the listing's first photo (product field "Màu theo ảnh đầu tiên", Minh 2026-11-03) in the Aris colour
  //    option: Macrame Style / Yarn Style (Vibes swatches, nothing ticked at first) or Macrame Color (25-colour list, which Aris
  //    starts on its first colour, Cream White). ?style=terracotta in the link wins when the listing has that colour. Multi-colour
  //    options (Macrame Color 1-4, Main Color ...) and Wooden Color are never touched. A colour the shopper picked (or the browser
  //    restored) is kept, and so is any colour once the shopper has touched the option. MBP.style is the drawing color only.
  //    The shown colour and the cart line (properties[Macrame Color] / [Macrame Style]) follow the pick and stay when the size
  //    changes; the list stays closed, the page does not scroll and the photo does not change (live V28/U08/V93, 2026-11-03).
  function colourGroup() {
    var opts = d.querySelectorAll('#avpoptions-container__v2 .avp-option');
    for (var i = 0; i < opts.length; i++) {
      var t = opts[i].querySelector('.apo-title') || opts[i].querySelector('label.avp-option-title');
      var name = t ? (t.textContent || '').replace(/\*/g, '').trim() : '';
      if (/^(macrame style|yarn style|macrame color)$/i.test(name)) return { el: opts[i], name: name };
    }
    return null;
  }
  // 'Terracotta Vibes', 'terracotta' -> 'terracotta'; 'Grey - Blue Vibes' -> 'greyblue'; 'Cream White' -> 'creamwhite'.
  function canon(s) {
    return String(s || '').toLowerCase().replace(/[^a-z]+/g, ' ').trim().replace(/\s+vibes?$/, '').replace(/ /g, '');
  }
  // In the 25-colour list each colour's row opens or closes the list when clicked, so a click would leave the list open over the
  // page. Do what a shopper's pick does without that: tick the radio and send Aris its change event (shown colour and cart line).
  // Vibes swatches: click the radio itself (a click on its label also focuses it, and the browser then scrolls down to it).
  function tick(g, input) {
    if (/select/.test(g.el.className)) {
      input.checked = true;
      input.dispatchEvent(new CustomEvent('change'));
    } else {
      input.click();
    }
  }
  function preselect() {
    var q = null;
    try { q = new URLSearchParams(location.search).get('style'); } catch (e) {}
    var wants = [q, MBP.pre].filter(function (w) { return w && w.trim(); });
    if (!wants.length) return;
    var touched = false;
    ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function (type) {
      d.addEventListener(type, function (e) {
        if (touched || !e.isTrusted) return;
        var g = colourGroup();
        if (g && e.target && g.el.contains(e.target)) touched = true;
      }, { capture: true, passive: true });
    });
    var valueOf = function (input) {
      var lab = input.value ? null : input.closest('label');
      return input.value || (lab ? (lab.textContent || '').trim() : '');
    };
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var g = colourGroup();
      var ins = g ? g.el.querySelectorAll('input[type="radio"]') : [];
      if (ins.length) {
        clearInterval(timer);
        var prop = d.querySelector('form[id^="product-form-"] [name="properties[' + g.name + ']"]');
        var c = g.el.querySelector('input[type="radio"]:checked');
        var cur = prop ? prop.value : c ? valueOf(c) : '';
        var auto = /select/.test(g.el.className) && cur === valueOf(ins[0]);
        if (touched || (cur && !auto)) { MBP.preselected = 'kept'; return; }
        // Exact colour first; then, for old ?style= links, a colour that starts with the word ('sage' -> Sage Green).
        for (var w = 0; w < wants.length; w++) {
          var want = canon(wants[w]), pre = wants[w].trim().toLowerCase() + ' ', hit = null;
          for (var i = 0; i < ins.length && !hit; i++) if (canon(valueOf(ins[i])) === want) hit = ins[i];
          for (var j = 0; j < ins.length && !hit; j++) if (valueOf(ins[j]).toLowerCase().indexOf(pre) === 0) hit = ins[j];
          if (hit) {
            if (valueOf(hit) !== cur) tick(g, hit);
            MBP.preselected = valueOf(hit);
            return;
          }
        }
        MBP.preselected = 'not found';
        return;
      }
      if (tries > 60) { clearInterval(timer); MBP.preselected = 'no colour option'; }
    }, 250);
  }

  // 7. Default variant when the link names none (best-selling or 2nd size, Minh 2026-10-31 and 2026-11-03; with the photo's colour
  //    when that is a Shopify option): snippets/mb-pdp-early.liquid ticks it while the page loads.
  //    Once the theme's variant-picker and product-info exist, the theme is told to read the ticked buttons through a hidden stub, so
  //    it refreshes price, cart forms, photos and URL as for a tap, without scrolling to the buttons. The same catch-up covers sizes
  //    tapped before the theme was ready (or restored by the browser), which the theme would otherwise miss.
  function fire(picker) {
    var stub = d.createElement('span');
    stub.id = 'mbp-default-stub';
    stub.hidden = true;
    picker.appendChild(stub);
    stub.dispatchEvent(new Event('change', { bubbles: true }));
    return stub;
  }
  function syncTheme() {
    var holder = d.querySelector('[data-mbp-default]'), want = null;
    try { if (holder) want = JSON.parse(holder.getAttribute('data-mbp-default')); } catch (e) {}
    MBP.early = window.MBP_EARLY || null;
    d.documentElement.classList.add('mbp-sw');
    if (!window.customElements || !window.Promise) return;
    Promise.all([customElements.whenDefined('variant-picker'), customElements.whenDefined('product-info')]).then(function () {
      var info = d.querySelector('product-info[id^="MainProduct-"]');
      var picker = info && info.querySelector('variant-picker');
      if (!picker) return;
      var radios = picker.querySelectorAll('input[type="radio"]');
      if (![].some.call(radios, function (r) { return r.checked !== r.defaultChecked; })) return;
      var onDefault = !!(MBP.early && want && want.options && want.options.every(function (val, i) {
        var c = picker.querySelector('.m-product-option--node[data-option-position="' + (i + 1) + '"] input[type="radio"]:checked');
        return c && c.closest('.m-product-option--node').getAttribute('data-value') === val;
      }));
      if (onDefault) MBP.defaulted = want.id; else MBP.caughtUp = true;
      d.addEventListener('variant:changed', function done() { MBP.synced = true; d.removeEventListener('variant:changed', done); });
      fire(picker);
    });
  }

  // 8. Product tabs ("Item details" and any other): the theme closes the open tab when another one opens. When a long tab above
  //    closes, the page loses thousands of pixels and jumps to the footer (Minh 2026-10-31; also in the original theme).
  //    Each tab now opens and closes on its own.
  function independentTabs() {
    if (!window.customElements) return;
    customElements.whenDefined('collapsible-tab').then(function () {
      [].forEach.call(d.querySelectorAll('.m-product-collapsible collapsible-tab'), function (tab) {
        tab.setAttribute('data-one-open', 'false');
        tab.oneAtATime = false;
      });
    });
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    var hit;
    if ((hit = t.closest('[data-mbp-open]'))) { e.preventDefault(); openSheet(); }
    else if ((hit = t.closest('[data-mbp-close]'))) { e.preventDefault(); closeSheet(); }
    else if ((hit = t.closest('.mbp-chip'))) { showSize(hit.getAttribute('data-key')); }
    else if ((hit = t.closest('[data-mbp-photo]'))) { e.preventDefault(); openPhoto(hit.getAttribute('data-mbp-photo')); }
    else if ((hit = t.closest('[data-mbp-lb]'))) { lightbox.hidden = true; d.documentElement.classList.remove('mbp-lock'); }
    else if ((hit = t.closest('[data-mbp-reviews]'))) {
      var w = reviewsWidget();
      if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSheet();
    if (lightbox && !lightbox.hidden) { lightbox.hidden = true; d.documentElement.classList.remove('mbp-lock'); }
  });

  syncTheme();
  independentTabs();
  delivery();
  preselect();
  if (!ugc()) {
    var again = 0, retry = setInterval(function () { if (ugc() || ++again > 6) clearInterval(retry); }, 1500);
  }
})();